<div class="tw-rounded-2xl tw-bg-white/40 tw-p-4">
  <span class="tw-text-lg tw-font-medium tw-uppercase tw-text-color-text-secondary sm:tw-text-sm">
    {{ "shareWithHeader" | i18n }}
  </span>

  @if (loading()) {
    <p class="tw-mt-3 tw-text-sm tw-text-color-text-secondary">{{ "loading" | i18n }}</p>
  } @else if (loadFailed()) {
    <div class="tw-mt-3 tw-flex tw-items-center tw-justify-between tw-gap-2">
      <span class="tw-text-sm tw-text-color-status-error-text" data-testid="teams-load-failed">
        {{ "unexpectedError" | i18n }}
      </span>
      <button
        type="button"
        class="tw-text-sm tw-text-color-text-action tw-underline"
        data-testid="teams-retry"
        (click)="load()"
      >
        {{ "tryAgain" | i18n }}
      </button>
    </div>
  } @else if (rows.length === 0) {
    <span
      class="tw-mt-3 tw-block tw-text-sm tw-text-color-text-secondary"
      data-testid="no-teams-available"
    >
      {{ "noTeamsAvailable" | i18n }}
    </span>
  } @else {
    <div class="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
      @for (row of rows; track row.collectionId) {
        <div
          class="tw-flex tw-cursor-pointer tw-items-center tw-gap-3 tw-rounded-xl tw-bg-color-surface-sunken tw-px-[14px] tw-py-3"
          data-testid="share-team-row"
          (click)="toggleRow(row)"
        >
          <div
            class="tw-flex tw-h-[22px] tw-w-[22px] tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded tw-border"
            [ngClass]="
              row.checked
                ? 'tw-border-color-action-primary tw-bg-color-action-primary'
                : 'tw-border-color-border-default tw-bg-color-surface-sunken tw-shadow-elevation-input'
            "
            role="checkbox"
            [attr.aria-checked]="row.checked"
          >
            @if (row.checked) {
              <icon [size]="3" [name]="'check-only'" [currentColor]="'light'"></icon>
            }
          </div>
          <div class="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-3">
            <div
              class="tw-flex tw-h-8 tw-w-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-color-surface-brand tw-text-[13px] tw-font-semibold tw-text-color-intent-brand"
            >
              {{ row.initial }}
            </div>
            <div class="tw-flex tw-min-w-0 tw-flex-col">
              <span class="tw-truncate tw-text-sm tw-font-medium tw-text-color-text-default">
                {{ row.name }}
              </span>
              @if (row.membersLabel) {
                <span class="tw-truncate tw-text-xs tw-text-color-text-secondary">
                  {{ row.membersLabel }}
                </span>
              }
            </div>
          </div>
        </div>
      }
    </div>

    <p class="tw-mt-3 tw-text-xs tw-text-color-text-secondary">
      {{ "teamSharingCaption" | i18n }}
    </p>
  }
</div>
